import {
  checkCorrectForm,
  deleteBudgetCorrectForm,
  getBudgetCorrectFormDetail,
  getBudgetCorrectFormList,
  saveBudgetCorrectForm,
} from '../services';

export default {
  namespace: 'revisedFormQuery',
  state: {},
  effects: {
    // 预算项目订正单据列表查询
    *getBudgetCorrectFormList({ payload }, { call }) {
      return yield call(getBudgetCorrectFormList, payload);
    },

    // 预算项目订正申请单保存
    *saveBudgetCorrectForm({ payload }, { call }) {
      return yield call(saveBudgetCorrectForm, payload);
    },

    // 预算项目订正申请单删除
    *deleteBudgetCorrectForm({ payload }, { call }) {
      return yield call(deleteBudgetCorrectForm, payload);
    },

    // 预算项目订正申请单详情
    *getBudgetCorrectFormDetail({ payload }, { call }) {
      return yield call(getBudgetCorrectFormDetail, payload);
    },

    // 检查预算项目订正申请单明细
    *checkCorrectForm({ payload }, { call }) {
      return yield call(checkCorrectForm, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
